import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { SafePipe } from '../../../../shared/pipes/safe.pipe';

@Component({
  selector: 'app-youtube-player',
  templateUrl: './youtube-player.component.html',
  styleUrls: ['./youtube-player.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SafePipe],
})
export class YoutubePlayerComponent implements OnInit, OnDestroy, OnChanges {
  @Input() videoId: string;
  @Input() url: string;
  @Input() width: number = 640;
  @Input() height: number = 390;
  @Input() autoplay: boolean = false;

  public embedUrl: string = '';

  constructor() {}

  ngOnInit() {
    if (!this.videoId && this.url) {
      this.videoId = this.getVideoIdFromUrl(this.url);
    }

    if (!this.videoId) {
      console.error('No video ID provided');
      return;
    }
  }

  ngOnDestroy() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['videoId'] && this.videoId) {
    } else if (changes['url'] && this.url) {
      const url = new URL(this.url);
      this.videoId = this.getVideoIdFromUrl(url.toString());
    }

    this.embedUrl = `https://www.youtube.com/embed/${this.videoId}`;
  }

  private getVideoIdFromUrl(url: string): string {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  }
}
